import React from "react";
import { Link } from "gatsby";
import { rhythm } from "../../utils/typography";
import "./index.css";

const Footer = () => {
  return (
    <div className="footer-main">
      <hr />
      <div className="footer-links">
        <div>
          <Link to={`/about`}>About</Link>
          {`  •  `}
          <Link to={`/writing`}>Writing</Link>
          {`  • `}
          <Link to={`/support`}>Support Us</Link>
        </div>
        <br />
        <div>
          <a
            href="https://instagram.com/words.cut.deepest"
            className="footer-secondary-links"
            target="blank"
          >
            Follow us on Instagram
          </a>
        </div>
        <div style={{ display: `none` }}>
          <a href="" className="footer-secondary-links" target="blank">
            Download the app
          </a>
        </div>
      </div>
      <div className="credits">
        Designed and developed by{" "}
        <a href="https://22boxes.com" target="blank">
          22Boxes.com
        </a>
      </div>
    </div>
  );
};

export default Footer;
